import { EpimsBaseEntityDto } from "./epim-base.dto";

export class AreaOfImpactDto extends EpimsBaseEntityDto{
    AreaofImpactId: string;
    PartyId: string;
    TerrainId:string;
    Area:number;
    UomId:string;
    Remarks:string;
    IncidentNotificationId:string;
    length: number;
}